import { render } from "./VideoSearch.vue?vue&type=template&id=d80a7846&scoped=true"
import script from "./VideoSearch.vue?vue&type=script&lang=js"
export * from "./VideoSearch.vue?vue&type=script&lang=js"

import "./VideoSearch.vue?vue&type=style&index=0&id=d80a7846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d80a7846"]])

export default __exports__